<template>
    <div id="user-settings">
        <div class="title">Postavke</div>
        <div class="subtitle">Promjena lozinke</div>
        <form class="change-password" v-on:submit.prevent="changePassword()" novalidate="true">
            <div class="form-field">
                <input id="password" type="password" v-model="oldPassword" />
                <label for="password" v-bind:class="oldPassword ? 'field-filled' : ''">Stara lozinka</label>
            </div>
            <div class="form-field">
                <input id="new-password" type="password" v-model="newPassword" v-on:change="validateNewPassword" />
                <label for="new-password" v-bind:class="newPassword ? 'field-filled' : ''">Nova lozinka</label>
                <div class="error" v-bind:style="{display: isNewPasswordValid ? 'none' : 'block'}">Lozinka nije valjana. Mora imati bar 8 znakova, jedno veliko slovo i jedan broj.</div>
            </div>
            <div class="form-field">
                <input id="repeated-new-password" type="password" v-model="repeatedNewPassword" v-on:change="validateRepeatedNewPassword" />
                <label for="repeated-new-password" v-bind:class="repeatedNewPassword ? 'field-filled' : ''">Ponovljena nova lozinka</label>
                <div class="error" v-bind:style="{display: isRepeatedNewPasswordValid ? 'none' : 'block'}">Lozinke se ne poklapaju.</div>
            </div>
            <div class="result" v-if="isChangeOver">
                <div class="you-made-it" v-if="didChangeSucceed">Lozinka je uspješno promijenjena.</div>
                <div class="error" v-else>Zahtjev za promjenom neuspješan.</div>
            </div>
            <button class="button" type="submit" value="submit" v-bind:disabled="passwordFormInvalid">POŠALJI</button>
        </form>
        <div class="subtitle newsletter">Newsletter</div>
        <div class="checkbox">
            <input type="checkbox" id="newsletterCheckbox" v-model="isNewsletterEnabled" v-on:change="updateUserNewsletter">
            <label for="newsletterCheckbox">Želim primati newsletter</label>
            <div class="newsletter-success" v-bind:class="wasNewsletterUpdateSuccessful ? 'you-made-it' : 'error'" v-bind:style="{visibility: isNewsletterUpdateDone ? 'visible' : 'hidden'}">
                {{ wasNewsletterUpdateSuccessful ? 'Postavke newslettera su uspješno promijenjene.' : 'Došlo je do pogreške pri zahtjevu. Molimo te da pokušaš ponovo.'}} 
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Settings',
        data() {
            return {
                oldPassword: '',
                newPassword: '',
                repeatedNewPassword: '',
                isNewPasswordValid: true,
                isRepeatedNewPasswordValid: true,
                didChangeSucceed: false,
                isChangeOver: false,
                isNewsletterEnabled: false,
                areNotificationsEnabled: false,
                isNewsletterUpdateDone: false,
                wasNewsletterUpdateSuccessful: true
            }
        },
        computed: {
            passwordFormInvalid: function() {
                return !this.oldPassword || !this.oldPassword.length || 
                this.oldPassword.length < 8 || !this.newPassword || !this.newPassword.length || !this.isNewPasswordValid ||
                !this.repeatedNewPassword || !this.repeatedNewPassword.length || !this.isRepeatedNewPasswordValid ||
                this.repeatedNewPassword !== this.newPassword;
            }
        },
        methods: {
            validateNewPassword: function() {
                this.isNewPasswordValid = this.newPassword && this.newPassword.length >= 8 && this.newPassword.toLowerCase() !== this.newPassword && /\d/.test(this.newPassword);
            },
            validateRepeatedNewPassword: function() {
                this.isRepeatedNewPasswordValid = this.newPassword && this.repeatedNewPassword && this.repeatedNewPassword === this.newPassword;
            },
            changePassword: function() {
                if(this.passwordFormInvalid || this.newPassword !== this.repeatedNewPassword)
                    return;

                this.$axios.post(`${this.$API_URL}/user/change-password`, {
                    oldPassword: this.oldPassword,
                    newPassword: this.newPassword
                })
                .then(() => {
                    this.didChangeSucceed = true;
                    this.isChangeOver = true;
                    this.oldPassword = null;
                    this.newPassword = null;
                    this.repeatedNewPassword = null;
                    setTimeout(() => this.isChangeOver = false, 5000);
                })
                // eslint-disable-next-line
                .catch(error => {
                    this.didChangeSucceed = false;
                    this.isChangeOver = true;
                    setTimeout(() => this.isChangeOver = false, 5000);
                });
            },
            updateUserNewsletter: function() {
              this.$axios.post(`${this.$API_URL}/user/change-newsletter`, { isNewsletterEnabled : this.isNewsletterEnabled })
                .then(() => {
                    this.wasNewsletterUpdateSuccessful = true;
                    this.isNewsletterUpdateDone = true;
                    setTimeout(() => { this.isNewsletterUpdateDone = false; }, 3000);
                }).catch(() => {
                    this.wasNewsletterUpdateSuccessful = false;
                    this.isNewsletterUpdateDone = true;
                    setTimeout(() => { this.isNewsletterUpdateDone = false; }, 3000);
                });
            }
        },
        created() {
            this.$axios.get(`${this.$API_URL}/user/is-newsletter-enabled`).then(response => {
                this.isNewsletterEnabled = response.data;
            });
        }
    }
</script>

<style scoped>
#user-settings {
    padding-left: 20px;
}

#user-settings .title {
    margin-top: 30px;
    font-size: 22px;
    font-weight: 800;
}

#user-settings .subtitle {
    font-size: 16px;
    font-weight: 700;
    margin-top: 20px;
}

#user-settings .subtitle.newsletter {
    margin-top: 80px;
}

#user-settings input {
    margin-top: 20px;
    border: none;
    background-color: #f9f9f9;
    border-bottom: 2px solid black;
    font-size: 14px;
    padding: 18px 0 5px 20px;
    width: 70%;
    outline: none;
}

#user-settings input:focus {
    border-bottom-color: #30cec1;
}

#user-settings .checkbox input {
    width: 10%;
}

#user-settings .error {
    width: 80%;
}

form > div {
    position: relative;
}

form > div.form-field > label {
    position: absolute;
    font-size: 16px;
    left: 20px;
    top: 34px;
    opacity: 0.7;
}

form > div.form-field input:focus + label,
form > div.form-field > label.field-filled {
    font-size: 14px;
    top: 22px;
    opacity: 0.6;
}

#user-settings form button {
    margin-top: 10px;
    float: right;
    margin-right: 20px;
}


#user-settings .you-made-it {
  color: #1d9b90;
}
</style>